export const API_ENDPOINT = 'publishers';


// WEBPACK FOOTER //
// ./src/state/modules/publisher/configurations/endpoints.js